module.exports = __webpack_public_path__ + "img/aestura.307ce551.svg";